module.exports = __webpack_public_path__ + "static/media/rejected.11b0d5bb.webp";